import store from '~store';
import router from '~router';

export default {
    /**
     * Handle response, show snackbar messages and redirect on another route if need
     * @param {object} resp
     * @param {string} successMessage
     * @param {string} errorMessage
     * @param {string} routeName
     * @param {string} redirectPath
     */
    handleResponse(
        resp,
        successMessage = undefined,
        errorMessage = undefined,
        routeName = undefined,
        redirectPath = undefined
    ) {
        // Check success response
        if (resp?.ok || resp?.status === 200) {
            // Show success message
            if (successMessage?.length) {
                store.dispatch('snackbar/showMessage', successMessage);
            }

            // Redirect to another route
            if (redirectPath?.length) {
                return router.replace({ path: redirectPath });
            }

            // Redirect to another route
            if (routeName?.length) {
                router.push({ name: routeName });
            }
        } else {
            let errorMessageText;
            let obj;

            if (resp?.status === 422) {
                if (
                    resp?.data?.message &&
                    resp?.data?.message[0]?.constraints
                ) {
                    obj = resp.data.message[0].constraints;
                } else if (
                    resp?.data?.message &&
                    resp?.data?.message[0]?.children &&
                    resp?.data?.message[0]?.children[0]?.constraints
                ) {
                    obj = resp.data.message[0].children[0].constraints;
                }

                if (typeof obj === 'object' && Object.keys(obj).length) {
                    errorMessageText = obj[Object.keys(obj)[0]];
                }

                if (typeof resp?.data?.message === 'string') {
                    errorMessageText = resp.data.message;
                }
            } else {
                errorMessageText = resp?.data?.message
                    ? resp.data.message
                    : null;
            }

            if (errorMessage) {
                errorMessageText = errorMessage;
            }

            // Show error message
            if (errorMessageText) {
                store.dispatch('snackbar/showMessage', errorMessageText);
            } else {
                // Redirect to another route
                if (routeName?.length) {
                    router.push({ name: routeName });
                }
            }
        }
    }
};
